<ng-container *ngIf="boondock">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Boondock Name & Description</ion-card-title>
      <div
        *ngIf="!boondockComplete.nameCompleted(descriptionForm.value) || !boondockComplete.descriptionTextCompleted(descriptionForm.value)"
        class="required-pill ion-float-end"
      >
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked
        *ngIf="boondockComplete.nameCompleted(descriptionForm.value) && boondockComplete.descriptionTextCompleted(descriptionForm.value)"
      ></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <h4>Name your site.</h4>
        <div class="title-information-wrapper">
          <p>Give your boondock a fun name and provide a summary of what CurbNTurfers can expect.</p>
        </div>
        <input
          [formControl]="name"
          id="site-name"
          name="site-name"
          type="text"
          class="text-input w-input"
          placeholder="Type your site name here..."
        />
        <p class="fine-print">
          Boondock names appear in the search results so be sure to make it stand out and intriguing to CurbNTurfers.
          Names have to be between 8 to 32 characters, and no special characters should be used.
        </p>
        <br />
        <h4>Describe your site.</h4>
        <p class="fine-print">
          We don&rsquo;t allow addresses, personal information, or website urls. Descriptions have to be at least 150
          characters long.
        </p>
        <p>Good views? What types of terrain or vegetation? Private? What&rsquo;s nearby?</p>
        <label for="site-description" class="sr-only">Site Description</label>
        <textarea
          [formControl]="description"
          name="site-description"
          id="site-description"
          placeholder="Describe your site and what makes your property unique..."
          class="site-description w-input"
        ></textarea>
        <div class="title-information-wrapper">
          <p class="fine-print">
            You&rsquo;ve written
            <strong>
              <span [class.text-danger]="descriptionLength < 150">{{ descriptionLength }}</span
              >/150
            </strong>
            character minimum.
          </p>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Photos of Boondock (3 Recommended)</ion-card-title>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-boondock-photos [form]="photoForm" [boondock]="boondock"> </curbnturf-boondock-photos>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Terrain</ion-card-title>
      <div *ngIf="!boondockComplete.terrainCompleted({landTypes: landTypesFormValue})" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="boondockComplete.terrainCompleted({landTypes: landTypesFormValue})"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-listing-terrain [landTypes]="landTypes"> </curbnturf-listing-terrain>

        <div class="divider-line"></div>

        <curbnturf-hazard-input [form]="hazardForm"></curbnturf-hazard-input>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
